<template>
    <div>
        <div class="mt-3">
            <template v-if="!$data._.exportLatest || [ 'done', 'failed', ].includes($data._.exportLatest.status)">
                <b-link @click="generate_excel">
                    全データExcelを生成する
                </b-link>
            </template>
            <template v-if="$data._.exportLatest">
                <span v-if="[ 'pending', ].includes($data._.exportLatest.status)" class="animation-blink">
                    全データExcelを準備中
                </span>
                <span v-if="[ 'processing', ].includes($data._.exportLatest.status)" class="animation-blink">
                    全データExcelを生成中
                </span>
                &emsp;
                <b-link v-if="[ 'done', ].includes($data._.exportLatest.status)" @click="download">
                    <font-awesome-icon class="fa-fw" icon="download" />
                    生成済({{ $data._.exportLatest.created_at }})
                </b-link>
                <span v-if="[ 'failed', ].includes($data._.exportLatest.status)">
                    生成エラー「{{ $data._.exportLatest.error }}」
                </span>
            </template>
        </div>

        <GridPage
            :form-default="{
                status: 'pending',
            }"
            :filters-default="{
                form_uuid: form_uuid,
                status: status,
                sort: '-sent_at',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '仮登録', value: 'pending' },
                        { text: '入金待ち', value: 'sent' },
                        { text: '入金確認中', value: 'paid' },
                        { text: '完了', value: 'completed' },
                        { text: 'キャンセル中', value: 'canceling' },
                        { text: 'キャンセル済', value: 'canceled' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 登録日', value: 'sent_at', },
                        { text: '▼ 登録日', value: '-sent_at' },
                        { text: '▲ 受付番号', value: 'id', },
                        { text: '▼ 受付番号', value: '-id' },
                        { text: '▲ 入金日', value: 'payment_settled_at', },
                        { text: '▼ 入金日', value: '-payment_settled_at' },
                    ],
                },
            ]"
            filters-q-placeholder="名前、メール、受付番号(-,0不要)、課金ID"
            form-modal-id=""
            search-action="answer/index"
            ref="grid"
            >
            <template v-slot:form="{ form, init }">
<!--
                <Answer :model="form" :init="init"></Answer>
-->
            </template>

            <template v-slot:column="{ item }">
                <b-col md="6" class="align-self-center">
                    <AnswerBadges :model="item" class="mb-1" />
                    <strong>受付番号</strong>
                    {{ item.meta.text.number }}
                    {{ item.name }}
                    <br>

                    <strong>メール</strong>
                    <a :href="`mailto:${item.email}`" target="_blank">
                        {{ item.email }}
                    </a><br>

                    <strong>決済</strong>
                    &yen;{{ item.payment_price | baseNumberFormatter }}
                    <template v-if="item.payment_provider">
                        (
                        {{ trans.labels['forms.payment_provider.' + item.payment_provider] }}
                        <template v-if="item.payment_provider_id">
                            :
                            {{ item.payment_provider_id }}
                        </template>
                        )
                    </template>
                </b-col>
    
                <b-col md="3" class="align-self-center">
                    <AnswerInfo :model="item" />
                </b-col>

                <b-col md="3" class="align-self-center">
                    <b-dropdown
                        text="詳細"
                        @click="windowOpen(item.meta.link.show)"
                        variant="light"
                        split
                        block
                        >
                        <b-dropdown-item-button v-if="[ 'sent', 'canceled', ].indexOf(item.status) >= 0" @click="pend(item)">
                            {{ trans.labels[`form_answers.status.pending`] }}にする
                        </b-dropdown-item-button>
<!--
                        <b-dropdown-item-button v-if="[ 'paid', ].indexOf(item.status) >= 0">
                            {{ trans.labels[`form_answers.status.sent`] }}にする
                        </b-dropdown-item-button>
                        <b-dropdown-item-button>
                            {{ trans.labels[`form_answers.status.paid`] }}にする
                        </b-dropdown-item-button>
-->
                        <b-dropdown-item-button v-if="[ 'paid', ].indexOf(item.status) >= 0" @click="complete(item)">
                            {{ trans.labels[`form_answers.status.completed`] }}にする
                        </b-dropdown-item-button>
<!--
                        <b-dropdown-item-button v-if="[ 'pending', 'sent', 'canceled', ].indexOf(item.status) >= 0">
                            {{ trans.labels[`form_answers.status.canceling`] }}にする
                        </b-dropdown-item-button>
-->
                        <b-dropdown-item-button v-if="[ 'canceling', ].indexOf(item.status) >= 0" @click="cancel(item)" variant="danger">
                            {{ trans.labels[`form_answers.status.canceled`] }}にする
                        </b-dropdown-item-button>

                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button @click="changeEmailName(item)" variant="warning">
                           メールアドレス・名前を変更
                        </b-dropdown-item-button>

                        <template v-if="[ 'canceled', ].indexOf(item.status) >= 0">
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item-button variant="danger" @click="destroy(item)">
                                完全に削除する
                            </b-dropdown-item-button>
                        </template>
                    </b-dropdown>
                </b-col>
            </template>
        </GridPage>

        <b-modal
            id="modal-email_name"
            @ok="changeEmailNameOk"
            :title="$data._.modalEmailName ? $data._.modalEmailName.meta.text.number : ''"
            >
            <template v-if="$data._.modalEmailName">
                <b-form-group>
                    <strong>メールアドレス</strong>
                    <b-form-input
                        v-model="$data._.modalEmailName.email"
                        type="email"
                        />
                    <input-error :errors="error.email" />
                </b-form-group>

                <b-form-group>
                    <strong>名前</strong><br>
                    <span>姓名の間にスペースなし</span>
                    <b-form-input
                        v-model="$data._.modalEmailName.name"
                        placeholder="山田太郎"
                        />
                    <input-error :errors="error.name" />
                </b-form-group>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Answer from '@/components/Answer.vue'
import AnswerBadges from '@/components/AnswerBadges.vue'
import AnswerInfo from '@/components/AnswerInfo.vue'
import InputError from '@/components/InputError.vue'

export default {
    components: {
        GridPage,
        Answer,
        AnswerBadges,
        AnswerInfo,
        InputError,
    },
    props: {
        form_uuid: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            required: false,
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {
            _: {
                modalEmailName: null,
                exportLatest: null,
                timerExport: null,
            },
            error: {},
        }
    },
    methods: {
        async complete (answer) {
            if (!confirm(this.trans.messages['info.click-to-complete-item'])) {
                return
            }

            this.error = {}
            const response = await this.$store.dispatch('answer/complete', answer)
            if (this.isResponseError(response)) {
//                this.fetchForm(false)
                return false
            }

            answer = Object.assign(answer, response.data)
        },
        async cancel (answer) {
            if (!confirm(this.trans.messages['info.click-to-cancel-item'])) {
                return
            }

            this.error = {}
            const response = await this.$store.dispatch('answer/cancel', {
                form_uuid: this.form_uuid,
                answer_uuid: answer.uuid,
                email_hashed: answer.email_hashed,
                updated_at: answer.updated_at,
            })
            if (this.isResponseError(response)) {
//                this.fetchForm(false)
                return false
            }

            answer = Object.assign(answer, response.data)
        },
        async pend (answer) {
            if (!confirm(this.trans.messages['info.click-to-pend-item'])) {
                return
            }

            this.error = {}
            const response = await this.$store.dispatch('answer/pend', answer)
            if (this.isResponseError(response)) {
//                this.fetchForm(false)
                return false
            }

            answer = Object.assign(answer, response.data)
        },
        async destroy (answer) {
            if (!confirm(this.trans.messages['info.click-to-delete-item'])) {
                return
            }

            this.error = {}
            const response = await this.$store.dispatch('answer/destroy', answer)
            if (this.isResponseError(response)) {
//                this.fetchForm(false)
                return false
            }

            this.$bus.$emit('form-modal:destroy-callback', response)
        },
        async generate_excel() {
//        async download() {
            const response = await this.$store.dispatch('answer/index', {
                form_uuid: this.form_uuid,
                dl: 1,
            })
            this.fetchExport();
        },
        async download() {
            const response = await this.$store.dispatch('exports/download', this.$data._.exportLatest.id)

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            var filename = 'file.xlsx'
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            var matches = filenameRegex.exec(response.headers['content-disposition'])
            if (matches != null && matches[1]) { 
                filename = matches[1].replace(/['"]/g, '')
            }

            link.setAttribute('download', filename)

            document.body.appendChild(link)
            link.click()
        },
        async changeEmailName (answer) {
            this.$bvModal.show('modal-email_name');
            this.$data._.modalEmailName = JSON.parse(JSON.stringify(answer));
//console.log(answer);
//           return;
            this.$data._.modalEmailName.form_uuid = this.form_uuid;
//            this.$data._.modalEmailName.answer_uuid = this.$data._.modalEmailName.uuid;
            this.error = {};
        },
        async changeEmailNameOk (event) {
            event.preventDefault();

            this.error = {};
            const response = await this.$store.dispatch('answer/change_email_name', this.$data._.modalEmailName)
            if (this.isResponseError(response)) {
                if (response.data.errors) {
                    this.error = response.data.errors;
                }
                return false;
            }
            this.$bvModal.hide('modal-email_name');

            this.$bus.$emit('form-modal:refresh-callback', response.data.id);
        },
        windowOpen(url) {
            window.open(url)
        },
        async fetchExport() {
            const response = await this.$store.dispatch('exports/index', {
                form_uuid: this.form_uuid,
            })
            if (response.data.hits) {
                this.$data._.exportLatest = response.data.hits[0];
//                window.location.href = res.data.url;
            }
        },
    },
    async mounted() {
        this.$data._.timerExport = setInterval(this.fetchExport, 30 * 1000);
        this.fetchExport();
    },
    async destroyed() {
        clearInterval(this.$data._.timerExport);
    },
}
</script>

